import React from "react";
import Icon from "@ant-design/icons";
import { CustomIconComponentProps } from "@ant-design/icons/es/components/Icon";

function ProductsDashboardIcon(props: Partial<CustomIconComponentProps>) {
  return (
    <Icon
      {...props}
      component={() => (
        <svg
          width={props.width || 16}
          height={props.height || 16}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.1875 8.106H7.89454V1.81303C7.89454 1.73569 7.83126 1.67241 7.75392 1.67241H7.29689C6.37351 1.6709 5.45894 1.85198 4.60581 2.20524C3.75267 2.5585 2.97781 3.07697 2.32579 3.73081C1.68368 4.37093 1.17205 5.12972 0.819347 5.96499C0.452325 6.8313 0.263992 7.7628 0.265636 8.70366C0.264124 9.62704 0.445207 10.5416 0.798467 11.3947C1.15173 12.2479 1.67019 13.0227 2.32403 13.6748C2.96915 14.3199 3.7215 14.8279 4.55821 15.1812C5.42453 15.5482 6.35603 15.7366 7.29689 15.7349C8.22026 15.7364 9.13483 15.5553 9.98797 15.2021C10.8411 14.8488 11.616 14.3304 12.268 13.6765C12.9131 13.0314 13.4211 12.279 13.7744 11.4423C14.1414 10.576 14.3298 9.64451 14.3281 8.70366V8.24663C14.3281 8.16928 14.2649 8.106 14.1875 8.106ZM11.4049 12.8486C10.8606 13.3886 10.2151 13.816 9.50531 14.1062C8.79556 14.3964 8.03553 14.5436 7.26876 14.5396C5.72013 14.5326 4.26466 13.9261 3.16954 12.831C2.06739 11.7289 1.46095 10.2628 1.46095 8.70366C1.46095 7.14448 2.06739 5.67846 3.16954 4.57632C4.12931 3.61655 5.36505 3.0312 6.69923 2.8976V9.30132H13.1029C12.9676 10.6425 12.377 11.8853 11.4049 12.8486ZM15.7344 7.12866L15.6887 6.63296C15.5393 5.01401 14.8203 3.48647 13.6637 2.33335C12.5062 1.17811 10.9818 0.463149 9.35353 0.311862L8.85607 0.266159C8.77345 0.259128 8.70314 0.322409 8.70314 0.405026V7.15678C8.70314 7.23413 8.76642 7.29741 8.84376 7.29741L15.5938 7.27983C15.6764 7.27983 15.7414 7.20952 15.7344 7.12866ZM9.89493 6.10561V1.59507C11.0022 1.82683 12.0184 2.37521 12.8199 3.17358C13.6233 3.97514 14.1734 4.99467 14.402 6.09331L9.89493 6.10561Z"
            fill={props.fill || "#262626"}
          />
        </svg>
      )}
    />
  );
}

export default ProductsDashboardIcon;
